import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiValueTypeModule } from '@components/ui-value-type/ui-value-type.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { AssetsPageComponent } from './assets.page';
import {
    UiRobotValueEditorComponent,
    UiSingleValueEditorComponent,
    UiValuePrimaryHintsComponent,
    UiValueSecondaryHintsComponent,
} from './components';
import { AssetModalComponent } from './modals';

const MODALS = [
    AssetModalComponent,
];

const LOCAL_COMPONENTS = [
    UiRobotValueEditorComponent,
    UiSingleValueEditorComponent,
    UiValuePrimaryHintsComponent,
    UiValueSecondaryHintsComponent,
];

@NgModule({
    imports: [
        CommonModule,
        UiSuggestModule,
        SharedModule,
        UiValueTypeModule,
        UiGridModule,
        UiGridResetModule,
        UiNgLetModule,
        UiAutofocusModule,
        UiSpinnerButtonModule,
        UiContentLoaderModule,
    ],
    declarations: [
        AssetsPageComponent,
        ...LOCAL_COMPONENTS,
        ...MODALS,
    ],
    exports: [
        AssetsPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class AssetModule { }
